import { Seo } from '../server/seo/types'

export const seoConfig: Seo = {
  id: 1,
  metaTitle: 'Aims Clinic',
  metaDescription:
    'Dr. Amy, a doctor who has been specializing in facial contouring for over 10 years, is ready to design individual treatments.',
  keywords: 'cosmetic services, clinic',
  metaRobots: 'index, follow',
  structuredData: null,
  metaViewport: 'width=device-width, initial-scale=1',
  canonicalURL: null,
  metaSocial: [],
  metaImage: null,
}
